import React, { useState, useRef, useEffect, useLayoutEffect, useMemo, useContext } from 'react';
import HamburgerMenu from '../../Components/HamburgerMenu/HamburgerMenu.jsx'; // Adjust the import path as necessary
import { useLocation, } from 'react-router-dom';
import UserService from '../../Services/user.service.js';
import ClientService from '../../Services/client.service.js';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDirectionByLanguage } from '../../hooks/useDirectionByLanguage.js';
import { ToastContainer, toast } from "react-toastify";
import { useSignalR } from '../../Contexts/signalR.js';
import ClientDocumentCountService from '../../Services/ClientDocumentCount.service.js';
import DocumentService from '../../Services/documents.service.js';
import { useSelector, useDispatch } from 'react-redux';
import {
  fetchDocumentCounts,
  selectDocumentCounts,
  selectIsCacheValid,
  selectDocumentCountsLoading,
  updateClientCount
} from '../../store/reducers/documentCountsSlice';
import {
  fetchMainPageData,
  fetchDocumentCountsForMainPage,
  selectMainPageData,
  selectIsMainPageCacheValid,
  selectMainPageLoading,
  updateClientInMainPage,
  updateDocumentCounts,
  clearMainPageCache,
  forceRefresh
} from '../../store/reducers/mainPageDataSlice';
import { invalidateMainPageCache, resetAllClientReduxData } from '../../Utils/cacheManager';
import clientsIcon from "../../assests/images/Main/clients.svg";
import subAccountantsIcon from "../../assests/images/Main/subAccountants.svg";
import SubAccountantService from '../../Services/subAccountant.service.js';
import Constants from '../../assests/Constants/constants.js';
import SummaryBar from '../../Components/Main/SummaryBar.jsx';
import EnumsService from '../../Services/enums.service.js';
import CircularProgress, {
  circularProgressClasses,
} from '@mui/material/CircularProgress';
import UpperPanelDetails from '../../Components/Widgets/UpperPanelDetails/UpperPanelDetails.jsx';
import { beautifyNumber } from '../../Utils/FormatNumber.js';
import { TextField, IconButton, InputAdornment, Tooltip, Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, Chip, FormControl, InputLabel, Select, MenuItem, Popover, FormControlLabel, Checkbox, Tabs, Tab } from '@mui/material';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import FitScreenIcon from '@mui/icons-material/FitScreen';
import SearchIcon from '@mui/icons-material/Search';
import AutocompleteSelectFilter from '../../Components/Widgets/AutocompleteSelectFilter/AutocompleteSelectFilter.jsx';
import ClientsDataGrid from '../../Components/Main/ClientsDataGrid.jsx';
import PuffLoader from "react-spinners/PuffLoader";
import PermissionService from '../../Services/permission.service.js';
import { PermissionsContext } from '../../Contexts/Permissions.js';
import Styles from './Main.module.scss';
import AssignmentService from '../../Services/assignment.service.js';
import FilterMonthYearPicker from '../../Components/Widgets/CustomDates/FilterMonthYearPicker/FilterMonthYearPicker.jsx';
import dayjs from 'dayjs';
import ReportsService from '../../Services/reports.service.js';
import { ClientHeaderProvider } from '../../Components/ClientDetails/SubComponents/ClientDetailsHeader/ClientHeaderContext.js';
import AccountantCards from '../../Components/ClientDetails/SubComponents/ClientDetailsHeader/AccountantCards.jsx';
import CustomBreadcrumbs from '../../Components/CustomBreadcrumbs/CustomBreadcrumbs.jsx'
import { ClientProvider } from '../../Contexts/ClientContext';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import TableChartIcon from '@mui/icons-material/TableChart';   // Excel-style icon
import ArticleIcon from '@mui/icons-material/Article';
import PasswordField from '../../Components/Main/PasswordField.jsx';
import PasswordDialog from '../../Components/Main/PasswordDialog.jsx';
import ExportClientsModal from '../../Components/Main/ExportClientsModal.jsx';
import ExportGeneratedDocumentsModal from '../../Components/Main/ExportGeneratedDocumentsModal.jsx';
import BulkClientActionsModal from '../../Components/Main/BulkClientActionsModal.jsx';
import { downloadClientsTableExcel, downloadClientsTablePdf } from '../../Utils/exportClientsTable.js';
import TransactionDocumentsExportService from '../../Services/transactionDocumentsExport.service.js';
import ClientBlockerWindow from '../../Components/ClientBlockerWindow/ClientBlockerWindow.jsx';
import PaymentService from '../../Services/payment.service.js';
import ClientTransferRequestService from '../../Services/clientTransferRequest.service.js';
import Swal from 'sweetalert2';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import RefreshIcon from '@mui/icons-material/Refresh';
import SendIcon from '@mui/icons-material/Send';
import CloseIcon from '@mui/icons-material/Close';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import { dir } from 'i18next';
import BrandXMark from '../../Components/Widgets/BrandXMark/BrandXMark';
import ReportingFollowUpOverviewModal from '../../Components/ReportingFollowUp/Overview/ReportingFollowUpOverviewModal.jsx';
import { REPORTING_FOLLOW_UP_SAVED_EVENT } from '../../Components/ReportingFollowUp/reportingFollowUpConstants';
import { confirmWithholdingReporting } from '../../Utils/withholdingReportingConfirm';

const CLIENT_TYPE_TABS = ['regular', 'manageOnly', 'taxRefund'];
const getClientTypeTab = (client) => {
  if (client?.isTaxRefund) return 'taxRefund';
  if (client?.isManageOnly) return 'manageOnly';
  return 'regular';
};

const resolveWithholdingReporting = (statuses, caseId) => {
  if (!statuses || !caseId) return false;
  return !!(statuses[caseId] ?? statuses[caseId.toLowerCase()]);
};

/** Map GetBalancesByCaseIds rows → caseId → collection balance (case-insensitive keys). */
const buildBalancesByCaseId = (balances) => {
  const acc = {};
  for (const item of balances || []) {
    const caseId = item?.caseId ?? item?.CaseId;
    if (!caseId) continue;
    const raw = item?.balance ?? item?.Balance;
    const balance = typeof raw === 'number' ? raw : Number(raw);
    const key = String(caseId);
    if (acc[key] === undefined || (Number.isFinite(balance) && balance !== 0)) {
      acc[key] = Number.isFinite(balance) ? balance : 0;
    }
  }
  return acc;
};

const collectionBalanceFor = (balancesByCaseId, caseId) => {
  if (!caseId || !balancesByCaseId) return undefined;
  if (balancesByCaseId[caseId] !== undefined) return balancesByCaseId[caseId];
  const lower = String(caseId).toLowerCase();
  const match = Object.entries(balancesByCaseId).find(([key]) => key.toLowerCase() === lower);
  return match ? match[1] : undefined;
};

const Main = () => {
  const navigate = useNavigate();

  const { i18n, t } = useTranslation();
  const direction = useDirectionByLanguage(i18n);
  const { permissions, permissionsState, loading: permissionsLoading, user, userTypeContext, token, isAccountant } = useContext(PermissionsContext);
  // Accountant-wide endpoints (balances, withholding reporting, follow-up overview) deny this permission.
  const isViewOnlySubAccountant = !isAccountant && !!permissionsState?.ViewSubAccountantClients;

  const [date, setDate] = useState(() => {
    const storedDateString = localStorage.getItem('Main_Date');
    return storedDateString ? new Date(storedDateString) : new Date();
  });
  // Set accountantId early from user context (needed for Redux selectors)
  const accountantId = user?.accountantId;

  const [isUserDataFetched, setIsUserDataFetched] = useState(false);
  const [clients, setClients] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasNext, setHasNext] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [sortOrder, setSortOrder] = useState('asc'); // 'asc' or 'desc'
  const pageSize = 5000; // Set your page size
  const location = useLocation();
  const arrivingFromLogin = Boolean(
    location.state?.fromLogin ||
    (typeof sessionStorage !== 'undefined' && sessionStorage.getItem('xtramFromLogin') === '1')
  );
  const [loginEnter, setLoginEnter] = useState(arrivingFromLogin);
  const [loginEnterHiding, setLoginEnterHiding] = useState(false);
  const [initialFetchComplete, setInitialFetchComplete] = useState(false);
  const loginEnterShownAtRef = useRef(Date.now());
  const [needsRefresh, setNeedsRefresh] = useState(false);
  const [loading, setLoading] = useState(false);
  const [dataFetched, setDataFetched] = useState(false);
  const [isLoadingDocumentCounts, setIsLoadingDocumentCounts] = useState(false);
  const [dataGridKey, setDataGridKey] = useState(0); // Force DataGrid re-render
  const [documentCountsVersion, setDocumentCountsVersion] = useState(0); // Version counter for filteredClients
  const lastCheckParamsRef = useRef({ date: null, clientCount: 0 });
  const fetchInProgressRef = useRef(false); // Prevent duplicate fetches
  const hasInitialFetchRef = useRef(false); // Track if initial fetch happened
  const fetchInitiatedRef = useRef(false); // Prevent React StrictMode double calls
  const countsUpdatePendingRef = useRef(false); // Track if counts update is pending

  useEffect(() => {
    if (!arrivingFromLogin || !loginEnter) return undefined;

    const reduceMotion =
      typeof window !== 'undefined' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const dismissOverlay = () => {
      sessionStorage.removeItem('xtramFromLogin');
      setLoginEnter(false);
      setLoginEnterHiding(false);
      navigate(location.pathname, { replace: true, state: {} });
    };

    if (reduceMotion) {
      if (initialFetchComplete) dismissOverlay();
      return undefined;
    }

    if (!initialFetchComplete) return undefined;

    const elapsed = Date.now() - loginEnterShownAtRef.current;
    const minVisibleMs = 480;
    const hideAfter = Math.max(0, minVisibleMs - elapsed);

    const hideTimer = window.setTimeout(() => setLoginEnterHiding(true), hideAfter);
    const doneTimer = window.setTimeout(dismissOverlay, hideAfter + 720);

    return () => {
      window.clearTimeout(hideTimer);
      window.clearTimeout(doneTimer);
    };
  }, [arrivingFromLogin, loginEnter, initialFetchComplete, location.pathname, navigate]);

  useEffect(() => {
    if (!arrivingFromLogin || !loginEnter || initialFetchComplete) return undefined;
    const safetyTimer = window.setTimeout(() => setInitialFetchComplete(true), 25000);
    return () => window.clearTimeout(safetyTimer);
  }, [arrivingFromLogin, loginEnter, initialFetchComplete]);

  const { documentUpdate } = useSignalR();
  const [clientsCount, setClientsCount] = useState(0);
  const [sortByNewest, setSortByNewest] = useState('');
  const [subAccountants, setSubAccountants] = useState([]);
  const [blockedClient, setBlockedClient] = useState(null);
  const [showBlockerWindow, setShowBlockerWindow] = useState(false);
  const [subAccountantsCount, setSubAccountantsCount] = useState(0);
  const [activeUsersOption, setActiveUsersOption] = useState({
    value: true,
    label: t('Active'),
  });
  const [exportModalOpen, setExportModalOpen] = useState(false);
  const [exportFormat, setExportFormat] = useState('pdf'); // 'pdf' | 'excel'
  const [tableView, setTableView] = useState(() => {
    try { return localStorage.getItem('main_ClientsDataGrid_tableView') || 'standard'; } catch { return 'standard'; }
  });
  const [fitColumns, setFitColumns] = useState(() => {
    try {
      const stored = localStorage.getItem('main_ClientsDataGrid_fitColumns');
      if (stored == null) {
        localStorage.setItem('main_ClientsDataGrid_fitColumns', '1');
        return true;
      }
      return stored !== '0';
    } catch {
      return true;
    }
  });
  const [fitNonce, setFitNonce] = useState(0);
  const setFitColumnsPersisted = (next) => {
    setFitColumns(next);
    try { localStorage.setItem('main_ClientsDataGrid_fitColumns', next ? '1' : '0'); } catch (_) {}
  };
  const [columnsPanelAnchor, setColumnsPanelAnchor] = useState(null);
  const [generatedDocsExportModalOpen, setGeneratedDocsExportModalOpen] = useState(false);
  const [generatedDocsExportFormat, setGeneratedDocsExportFormat] = useState('pdf');
  const [activeUsers, setActiveUsers] = useState(true);
  // New state to store permissions

  const [isSubAccSelectDisabled, setIsSubAccSelectDisabled] = useState(false);
  const [pwdDialogOpen, setPwdDialogOpen] = useState(false);
  const [pwdValue, setPwdValue] = useState('');
  const [selectedClient, setSelectedClient] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [pwdError, setPwdError] = useState("");
  const [transferRequests, setTransferRequests] = useState([]);
  const [transferRequestsLoading, setTransferRequestsLoading] = useState(false);
  const [transferRequestActionId, setTransferRequestActionId] = useState(null);
  const [withholdingReportingSavingCaseId, setWithholdingReportingSavingCaseId] = useState(null);
  const [selectedClientIds, setSelectedClientIds] = useState([]);
  const [clientTypeTab, setClientTypeTab] = useState(() => {
    try {
      const saved = localStorage.getItem('main_clientTypeTab');
      return CLIENT_TYPE_TABS.includes(saved) ? saved : 'regular';
    } catch { return 'regular'; }
  });
  const [bulkSendModalOpen, setBulkSendModalOpen] = useState(false);
  const [bulkSendLoading, setBulkSendLoading] = useState(false);
  const [followUpOverviewClients, setFollowUpOverviewClients] = useState(null);

  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = (event) => event.preventDefault();

  // Redux hooks
  const dispatch = useDispatch();
  const cachedDocumentCounts = useSelector((state) => selectDocumentCounts(state, accountantId));
  const isCacheValid = useSelector((state) => selectIsCacheValid(state, accountantId));
  const isDocumentCountsLoading = useSelector((state) => selectDocumentCountsLoading(state, accountantId));

  // Main page data caching
  const cachedMainPageData = useSelector((state) => selectMainPageData(state, accountantId));
  const isMainPageCacheValid = useSelector((state) => selectIsMainPageCacheValid(state, accountantId, date));
  const isMainPageLoading = useSelector((state) => selectMainPageLoading(state, accountantId));

  const accountingManagementType = useMemo(() => {
    return Constants.AccountManagementOptions?.map(option => ({
      value: option.name,
      label: option.name,
    }));
  }, [Constants.AccountManagementOptions]);

  const caseTypeOptions = useMemo(
    () => Constants.CaseTypeOptions.map((option) => ({ value: option.value, label: t(option.name) })),
    [t]
  );
  const [caseTypeFilter, setCaseTypeFilter] = useState(() => {
    try {
      const saved = JSON.parse(localStorage.getItem('main_caseTypeFilter') || '[]');
      return Array.isArray(saved) ? saved : [];
    } catch {
      return [];
    }
  });
  const handleCaseTypeFilterChange = (event, newValue) => {
    const next = newValue || [];
    setCaseTypeFilter(next);
    try { localStorage.setItem('main_caseTypeFilter', JSON.stringify(next)); } catch (_) {}
  };

  const activeOption = [
    {
      value: true,
      label: t('Active'),
    },
    {
      value: false,
      label: t('Inactive'),
    }
  ];
  const reportStatusOptions = [
    { value: 'reported', label: t('reported') },
    { value: 'notReported', label: t('notReported') },
    { value: 'notReportedperiod', label: t('notReportedperiod') },
    { value: 'notForReport', label: t('notForReport') },
  ];

  const [accountOptionSelected, setAccountOptionSelected] = useState(() => {
    const savedValues = JSON.parse(localStorage.getItem('accountOptionSelected') || '[]');
    return savedValues;
  });

  const [optionSelected, setOptionSelected] = useState(() => {
    const savedOptions = localStorage.getItem('optionSelected');
    return savedOptions ? JSON.parse(savedOptions) : [];
  });
  const [vatStatusFilter, setVatStatusFilter] = useState([]);
  const [advanceStatusFilter, setAdvanceStatusFilter] = useState([]);

  // Update localStorage when optionSelected changes
  useEffect(() => {
    localStorage.setItem('optionSelected', JSON.stringify(optionSelected));
  }, [optionSelected]);

  const handleAccManagmentChange = (event, newValue) => {
    setAccountOptionSelected(newValue);
    localStorage.setItem('accountOptionSelected', JSON.stringify(newValue));
  };

  const handleDateChange = async (newValue, type) => {
    const newDate = new Date(newValue);
    let updatedDate;

    if (type === 'year') {
      updatedDate = new Date(Date.UTC(newDate.getFullYear(), date.getMonth(), 10));
    } else if (type === 'month') {
      updatedDate = new Date(Date.UTC(date.getFullYear(), newDate.getMonth(), 10));
    }

    setDate(updatedDate);

    // Save the updated date in localStorage for persistence
    localStorage.setItem('Main_Date', updatedDate.toISOString());

    // Only the report statuses depend on the date here; they refresh from the date-change effect.
    if (isViewOnlySubAccountant) return;

    // Clear Redux cache when date changes (balances/reports are date-dependent)
    if (accountantId) {
      console.log('🗑️ Clearing cache due to date change');
      dispatch(clearMainPageCache({ accountantId }));
    }

    // Force fresh fetch so we never accidentally reuse cached client/balance/doc-count data
    // (important when date changes are triggered during typing).
    await fetchClientsData(user.accountantId, token, 1, pageSize, true, true, updatedDate, true);

  };


  const handleActiveUsersChange = (event, newValue) => {
    let isActive;
    if (!newValue) {
      isActive = newValue?.value || true;
    } else {
      isActive = newValue.value;
    }
    setActiveUsers(isActive);
    setActiveUsersOption(newValue);

    // Clear cache when switching between active/inactive (different data sets)
    if (accountantId && isActive !== activeUsers) {
      console.log('🗑️ Clearing cache due to active/inactive filter change');
      dispatch(clearMainPageCache({ accountantId }));
    }
  };

  const handleSubAccChange = (event, newValue) => {
    setOptionSelected(newValue);
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleSort = () => {
    setSortByNewest('');
    setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
  };

  // Manual refresh handler - clears cache and refetches
  const handleManualRefresh = async () => {
    if (accountantId) {
      console.log('🔄 Manual refresh triggered by user');
      invalidateMainPageCache(accountantId);
      hasInitialFetchRef.current = false;
      fetchInProgressRef.current = false;

      // Refetch data
      if (isViewOnlySubAccountant) {
        await fetchSubAccountantIdClientsData(user.subAccountantId, accountantId, token, 1, pageSize, true);
      } else {
        await Promise.all([
          fetchClientsData(accountantId, token, 1, pageSize, true, true, date),
          fetchSubAccountantsData(accountantId, token, true)
        ]);
      }
    }
  };

  const isRtl = ['he', 'ar'].includes(i18n.language);

  const fetchTransferRequests = React.useCallback(async () => {
    if (!token || !accountantId) return;
    setTransferRequestsLoading(true);
    try {
      const listRes = await ClientTransferRequestService.List(token);
      setTransferRequests(listRes.success ? listRes.data : []);
    } catch (e) {
      setTransferRequests([]);
    } finally {
      setTransferRequestsLoading(false);
    }
  }, [token, accountantId]);

  React.useEffect(() => {
    if (token && accountantId) fetchTransferRequests();
  }, [token, accountantId, fetchTransferRequests]);

  const transferRequestsAssignedToMe = React.useMemo(() => {
    const pending = 0;
    return (transferRequests || []).filter(
      (r) => r.assignedToAccountantId === accountantId && r.status === pending
    );
  }, [transferRequests, accountantId]);

  const handleTransferApprove = async (requestId) => {
    const confirmResult = await Swal.fire({
      icon: 'question',
      title: t('RequestTransferApproveConfirmTitle'),
      text: t('RequestTransferApproveConfirmText'),
      showCancelButton: true,
      confirmButtonText: t('Yes'),
      cancelButtonText: t('Cancel'),
    });
    if (!confirmResult.isConfirmed) return;
    setTransferRequestActionId(requestId);
    try {
      const result = await ClientTransferRequestService.Approve(token, { requestId, notes: null });
      if (result.success) {
        await Swal.fire({ icon: 'success', title: t('RequestTransferApproveSuccess') });
        fetchTransferRequests();
      } else {
        await Swal.fire({ icon: 'error', title: t('RequestTransferFailed'), text: result.error });
      }
    } catch (e) {
      await Swal.fire({ icon: 'error', title: t('RequestTransferFailed'), text: e?.message });
    } finally {
      setTransferRequestActionId(null);
    }
  };

  const handleTransferReject = async (requestId) => {
    const confirmResult = await Swal.fire({
      icon: 'question',
      title: t('RequestTransferRejectConfirmTitle'),
      text: t('RequestTransferRejectConfirmText'),
      showCancelButton: true,
      confirmButtonText: t('Yes'),
      cancelButtonText: t('Cancel'),
    });
    if (!confirmResult.isConfirmed) return;
    setTransferRequestActionId(requestId);
    try {
      const result = await ClientTransferRequestService.Reject(token, { requestId, notes: null });
      if (result.success) {
        await Swal.fire({ icon: 'success', title: t('RequestTransferRejectSuccess') });
        fetchTransferRequests();
      } else {
        await Swal.fire({ icon: 'error', title: t('RequestTransferFailed'), text: result.error });
      }
    } catch (e) {
      await Swal.fire({ icon: 'error', title: t('RequestTransferFailed'), text: e?.message });
    } finally {
      setTransferRequestActionId(null);
    }
  };

  const formatSubAccountantOptionLabel = (name) => {
    const displayName = (name || '').trim();
    return displayName || t("Accountant");
  };

  const fetchSubAccountantsData = async (accountantId, token, isFirstFetch) => {
    try {
      const [data, accountantResult] = await Promise.all([
        SubAccountantService.GetSubAccountantByAccountantId(token, accountantId),
        SubAccountantService.GetAccountantById(token, accountantId),
      ]);
      if (isFirstFetch) {
        let transformedData = data.map(item => ({
          label: formatSubAccountantOptionLabel(item.name),
          value: item.subAccountantId
        }));
        if (accountantId) {
          const accountantOption = {
            label: formatSubAccountantOptionLabel(accountantResult?.name || t("Accountant")),
            value: accountantId,
          };
          const exists = transformedData.some((x) => x.value === accountantOption.value);
          if (!exists) {
            transformedData = [accountantOption, ...transformedData];
          }
        }
        setSubAccountants(transformedData);
        setSubAccountantsCount(transformedData.length);
      } else {
        setSubAccountants([...subAccountants, ...data]);
      }
    } catch (error) {
      console.error(error);
      toast.error(t('fetchSubAccountantsDataError'));
    }
  };


  const fetchClientsData = async (
    accountantId,
    token,
    page,
    pageSize,
    isFirstFetch,
    isAccountant = false,
    date,
    forceRefresh = false
  ) => {
    console.log('🔍 fetchClientsData called:', {
      accountantId,
      page,
      isFirstFetch,
      isInProgress: fetchInProgressRef.current,
      isCacheValid: isMainPageCacheValid,
      hasCachedData: !!cachedMainPageData
    });

    // Prevent duplicate concurrent calls
    if (fetchInProgressRef.current) {
      console.log('⚠️ Fetch already in progress, skipping duplicate call');
      return;
    }

    fetchInProgressRef.current = true;
    setLoading(true);

    try {
      // Check if we have valid cached data in Redux for ALL main page data
      // Only use cache for first fetch (page 1), not for pagination
      if (!forceRefresh && isFirstFetch && isMainPageCacheValid && cachedMainPageData && cachedMainPageData.clients) {
        const hasDocumentCounts = cachedMainPageData.documentCounts && cachedMainPageData.documentCounts.length > 0;

        console.log('📦 Using cached main page data from Redux', {
          clientsCount: cachedMainPageData.clients?.clients?.length || 0,
          hasDocumentCounts
        });

        // Build enriched clients from cache
        const { clients: clientsData, clientsForAccountant, assignments, balances, vatStatuses, advanceStatuses, documentCounts, documentCountsForAccountant, withholdingReportingStatuses } = cachedMainPageData;

        // Build maps from cached data
        const assignmentsByCaseId = assignments.reduce(
          (acc, { caseId, unfinishedAssignmentsCount }) => {
            acc[caseId || "0"] = unfinishedAssignmentsCount;
            return acc;
          },
          {}
        );

        const balancesByCaseId = buildBalancesByCaseId(balances);

        const buildCountsMap = (items, keyName) => {
          return items?.reduce((acc, cur) => {
            acc[cur.caseId] = cur[keyName];
            return acc;
          }, {}) || {};
        };

        const totalCountsMap = buildCountsMap(documentCounts, "totalCounts");
        const totalCountsMapAcct = buildCountsMap(documentCountsForAccountant, "totalCounts");

        // Determine if we have counts data
        const hasCountsData = Object.keys(totalCountsMap).length > 0 || Object.keys(totalCountsMapAcct).length > 0;

        // Enrich clients with cached data
        const enrichedClients = clientsData.clients.map((client) => {
          // If no counts data in cache, use null (will show loading)
          // Otherwise use the count from cache or 0
          const count = totalCountsMap[client.caseId] ?? totalCountsMapAcct[client.caseId];
          const collectionBalance = collectionBalanceFor(balancesByCaseId, client.caseId);

          return {
            ...client,
            totalCounts: hasCountsData ? (count ?? 0) : null,
            balance: collectionBalance !== undefined ? collectionBalance : 0,
            unfinishedAssignments: assignmentsByCaseId[client.caseId] || 0,
            vatReportStatus: vatStatuses[client.caseId.toLowerCase()] || "notReported",
            advanceReportStatus: advanceStatuses[client.caseId.toLowerCase()] || "notReported",
            withholdingReporting: resolveWithholdingReporting(withholdingReportingStatuses, client.caseId),
          };
        });

        // Add additional accountant clients if needed
        if (isAccountant && clientsForAccountant) {
          const additionalEnrichedClients = clientsForAccountant.clients.map(
            (client) => {
              const count = totalCountsMapAcct[client.caseId];
              const collectionBalance = collectionBalanceFor(balancesByCaseId, client.caseId);
              return {
                ...client,
                totalCounts: hasCountsData ? (count ?? 0) : null,
                balance: collectionBalance !== undefined ? collectionBalance : 0,
                unfinishedAssignments: assignmentsByCaseId[client.caseId] || 0,
                withholdingReporting: resolveWithholdingReporting(withholdingReportingStatuses, client.caseId),
              };
            }
          );
          enrichedClients.push(...additionalEnrichedClients);
        }

        // Update UI with cached data
        setClients(enrichedClients);
        setDataFetched(true);
        setHasNext(clientsData.hasNext);
        setCurrentPage(page);
        setClientsCount(enrichedClients.length);
        setLoading(false);
        fetchInProgressRef.current = false;

        // If cache doesn't have document counts, fetch them in background
        if (!hasDocumentCounts) {
          console.log('⚠️ Cache missing document counts, fetching in background');
          setIsLoadingDocumentCounts(true);
          fetchDocumentCountsInBackground(accountantId, token, page, pageSize, isAccountant, forceRefresh);
        }

        return; // Skip main API call - using cached data
      }

      // Cache is invalid or empty - fetch fresh data from API
      console.log('🔄 Fetching FRESH main page data and caching in Redux');

      // Dispatch Redux action to fetch all main data
      const result = await dispatch(fetchMainPageData({
        accountantId,
        token,
        page,
        pageSize,
        date,
        isAccountant
      })).unwrap();

      // Build enriched clients from fresh data
      const { clients: clientsData, clientsForAccountant, assignments, balances, vatStatuses, advanceStatuses, withholdingReportingStatuses } = result;
      console.log('clientsData', clientsData);
      const assignmentsByCaseId = assignments.reduce(
        (acc, { caseId, unfinishedAssignmentsCount }) => {
          acc[caseId || "0"] = unfinishedAssignmentsCount;
          return acc;
        },
        {}
      );

      const balancesByCaseId = buildBalancesByCaseId(balances);

      // Enrich primary clients (preserve existing totalCounts if available)
      const enrichedClients = clientsData.clients.map((client) => {
        // Preserve existing totalCounts if this client already exists in state
        const existingClient = clients.find(c => c.caseId === client.caseId);
        const preservedTotalCounts = existingClient?.totalCounts;
        const collectionBalance = collectionBalanceFor(balancesByCaseId, client.caseId);

        return {
          ...client,
          // Only set to null if we don't have an existing value (preserve updated counts)
          totalCounts: preservedTotalCounts !== undefined ? preservedTotalCounts : null,
          balance: collectionBalance !== undefined ? collectionBalance : 0,
          unfinishedAssignments: assignmentsByCaseId[client.caseId] || 0,
          vatReportStatus: vatStatuses[client.caseId.toLowerCase()] || "notReported",
          advanceReportStatus: advanceStatuses[client.caseId.toLowerCase()] || "notReported",
          withholdingReporting: resolveWithholdingReporting(withholdingReportingStatuses, client.caseId),
        };
      });

      // If user is an accountant, enrich additional clients and merge
      if (isAccountant && clientsForAccountant) {
        const additionalEnrichedClients = clientsForAccountant.clients.map(
          (client) => {
            // Preserve existing totalCounts if this client already exists in state
            const existingClient = clients.find(c => c.caseId === client.caseId);
            const preservedTotalCounts = existingClient?.totalCounts;
            const collectionBalance = collectionBalanceFor(balancesByCaseId, client.caseId);

            return {
              ...client,
              // Only set to null if we don't have an existing value (preserve updated counts)
              totalCounts: preservedTotalCounts !== undefined ? preservedTotalCounts : null,
              balance: collectionBalance !== undefined ? collectionBalance : 0,
              unfinishedAssignments: assignmentsByCaseId[client.caseId] || 0,
              withholdingReporting: resolveWithholdingReporting(withholdingReportingStatuses, client.caseId),
            };
          }
        );
        enrichedClients.push(...additionalEnrichedClients);
      }

      // Removed automatic blocking check - will only check when clicking on client

      // Update state with new data (show UI immediately)
      // Use functional update to preserve any existing totalCounts that were updated
      if (isFirstFetch) {
        setClients(enrichedClients);
      } else {
        setClients((prev) => {
          // Merge new clients with existing, preserving totalCounts from existing
          const existingMap = new Map(prev.map(c => [c.caseId, c]));
          const merged = enrichedClients.map(newClient => {
            const existing = existingMap.get(newClient.caseId);
            // Preserve totalCounts from existing if it's not null (meaning it was updated)
            if (existing && existing.totalCounts !== null && existing.totalCounts !== undefined) {
              return { ...newClient, totalCounts: existing.totalCounts };
            }
            return newClient;
          });
          return [...prev, ...merged];
        });
      }
      setDataFetched(true);
      setHasNext(clientsData.hasNext);
      setCurrentPage(page);
      setClientsCount((prev) =>
        isFirstFetch ? enrichedClients.length : prev + enrichedClients.length
      );

      // Stop loading - UI is ready to show
      setLoading(false);
      fetchInProgressRef.current = false;

      // Set loading state for document counts
      setIsLoadingDocumentCounts(true);

      // Fetch document counts in background (non-blocking) and store in Redux
      fetchDocumentCountsInBackground(accountantId, token, page, pageSize, isAccountant, forceRefresh);

    } catch (error) {
      console.error(error);
      toast.error(t("fetchClientsDataError"));
      setLoading(false);
      fetchInProgressRef.current = false;
    }
  };

  // Helper function to fetch document counts without blocking the UI
  // Uses Redux for caching to prevent unnecessary API calls
  const fetchDocumentCountsInBackground = async (
    accountantId,
    token,
    page,
    pageSize,
    isAccountant,
    forceRefresh = false
  ) => {
    try {
      // If main page cache has document counts AND they're not empty, use them
      if (!forceRefresh && cachedMainPageData?.documentCounts && cachedMainPageData.documentCounts.length > 0) {
        console.log('📦 Using cached document counts from Redux:', cachedMainPageData.documentCounts.length, 'items');

        const buildCountsMap = (items, keyName) => {
          return items?.reduce((acc, cur) => {
            acc[cur.caseId] = cur[keyName];
            return acc;
          }, {}) || {};
        };

        const totalCountsMap = buildCountsMap(cachedMainPageData.documentCounts, "totalCounts");
        const totalCountsMapAcct = buildCountsMap(cachedMainPageData.documentCountsForAccountant, "totalCounts");

        // Use functional update to ensure we have latest state
        setClients((currentClients) => {
          console.log('📦 Applying cached counts to', currentClients.length, 'clients');

          const updatedClients = currentClients.map((client) => {
            const count = totalCountsMap[client.caseId] ?? totalCountsMapAcct[client.caseId];
            return {
              ...client,
              // If count found in cache, use it; otherwise 0
              totalCounts: count ?? 0,
            };
          });

          // Mark that counts update is pending - useEffect will handle the re-render
          countsUpdatePendingRef.current = true;

          return updatedClients;
        });

        setIsLoadingDocumentCounts(false); // Not loading if from cache

        // Force immediate re-render by updating version and key
        setDocumentCountsVersion(prev => prev + 1);
        setTimeout(() => {
          setDataGridKey(prev => prev + 1);
        }, 0);

        console.log('✅ Cached document counts applied');
        return; // Skip API call
      }

      // Cache is invalid or empty, fetch from API and store in Redux
      console.log('🔄 Fetching fresh document counts (cache empty or invalid)');
      setIsLoadingDocumentCounts(true); // Start loading indicator

      const result = await dispatch(fetchDocumentCountsForMainPage({
        accountantId,
        token,
        page,
        pageSize,
        isAccountant
      })).unwrap();

      console.log('📊 Document counts fetched:', result.documentCounts?.length || 0, 'items');

      // Build counts map from fresh data
      const buildCountsMap = (items, keyName) => {
        return items?.reduce((acc, cur) => {
          acc[cur.caseId] = cur[keyName];
          return acc;
        }, {}) || {};
      };

      const totalCountsMap = buildCountsMap(result.documentCounts, "totalCounts");
      const totalCountsMapAcct = buildCountsMap(result.documentCountsForAccountant, "totalCounts");

      // Update ALL clients with document counts using functional update
      // This ensures we're working with the latest clients state
      setClients((currentClients) => {
        console.log('📊 Updating clients with counts, current clients:', currentClients.length);

        if (currentClients.length === 0) {
          console.warn('⚠️ No clients to update! Clients array is empty');
          return currentClients;
        }

        const updatedClients = currentClients.map((client) => {
          const count = totalCountsMap[client.caseId] ?? totalCountsMapAcct[client.caseId];
          const newCount = count ?? 0;



          return {
            ...client,
            totalCounts: newCount,
          };
        });

        console.log('✅ Document counts updated', {
          totalUpdated: updatedClients.length,
          nullsFound: currentClients.filter(c => c.totalCounts === null).length,
          sampleCounts: updatedClients.slice(0, 3).map(c => ({ id: c.caseId, count: c.totalCounts }))
        });

        // Mark that counts update is pending - useEffect will handle the re-render
        countsUpdatePendingRef.current = true;

        return updatedClients;
      });

      setIsLoadingDocumentCounts(false);

      // Force immediate re-render after state update
      // Update version first to force filteredClients recalculation
      setDocumentCountsVersion(prev => {
        const newVersion = prev + 1;
        console.log('🔄 Document counts version updated (fresh fetch):', newVersion);
        return newVersion;
      });

      // Then update key to force DataGrid remount
      setTimeout(() => {
        setDataGridKey(prev => {
          const newKey = prev + 1;
          console.log('🔄 DataGrid key updated (fresh fetch):', newKey);
          return newKey;
        });
      }, 0);
    } catch (error) {
      console.error("Error fetching document counts in background:", error);
      setIsLoadingDocumentCounts(false); // Stop loading on error

      // Set counts to 0 on error (better than staying null forever)
      setClients((prevClients) =>
        prevClients.map((client) => ({
          ...client,
          totalCounts: client.totalCounts ?? 0,
        }))
      );
    }
  };



  // View-only sub-accountants: balances and withholding reporting are accountant-wide and not fetched here.
  const fetchSubAccountantIdClientsData = async (subAccountantId, accountantId, token, page, pageSize, isFirstFetch) => {
    try {
      setLoading(true);

      const [clientsData, documentCounts] = await Promise.all([
        ClientService.GetMinimalClientsBySubAccountantId(accountantId, subAccountantId, token, page, pageSize, true),
        ClientDocumentCountService.getTotalCountClientDocumentCountsBySubAccountantId(accountantId, subAccountantId, token, page, pageSize, true),
      ]);

      const totalCountsByCaseId = (documentCounts || []).reduce((acc, current) => {
        acc[current.caseId] = current.totalCounts;
        return acc;
      }, {});

      const enrichedClients = (clientsData?.clients || []).map(client => ({
        ...client,
        totalCounts: totalCountsByCaseId[client.caseId] || 0,
      }));

      if (isFirstFetch) {
        setClients(enrichedClients);
      } else {
        setClients(prevClients => [...prevClients, ...enrichedClients]);
      }

      setDataFetched(true);
      setHasNext(!!clientsData?.hasNext);
      setCurrentPage(page);
      setClientsCount(enrichedClients.length);
    } catch (error) {
      console.error(error);
      toast.error(t('fetchClientsDataError'));
    } finally {
      setLoading(false);
    }
  };

  // Reset fetch refs on unmount so that when user navigates back to Main we refetch and show data
  useEffect(() => {
    return () => {
      fetchInitiatedRef.current = false;
      hasInitialFetchRef.current = false;
      fetchInProgressRef.current = false;
    };
  }, []);

  // Reset fetch flag + local client list when accountantId changes (logout / different user)
  useEffect(() => {
    if (accountantId) {
      console.log('🔄 AccountantId changed, resetting fetch flag:', accountantId);
      hasInitialFetchRef.current = false;
      fetchInProgressRef.current = false;
      fetchInitiatedRef.current = false;
      setClients([]);
      setClientsCount(0);
      setCurrentPage(1);
      setHasNext(false);
      setDataFetched(false);
      setSubAccountants([]);
      setSubAccountantsCount(0);
    }
  }, [accountantId]);

  // Hydrate clients from Redux cache when local state is empty (e.g. after navigate back) so table is never blank
  useEffect(() => {
    if (
      clients.length > 0 ||
      !accountantId ||
      isViewOnlySubAccountant ||
      !isMainPageCacheValid ||
      !cachedMainPageData?.clients?.clients?.length
    ) {
      return;
    }
    const {
      clients: clientsData,
      clientsForAccountant,
      assignments,
      balances,
      vatStatuses,
      advanceStatuses,
      documentCounts,
      documentCountsForAccountant,
      withholdingReportingStatuses,
    } = cachedMainPageData;
    const assignmentsByCaseId = assignments.reduce(
      (acc, { caseId, unfinishedAssignmentsCount }) => {
        acc[caseId || "0"] = unfinishedAssignmentsCount;
        return acc;
      },
      {}
    );
    const balancesByCaseId = buildBalancesByCaseId(balances);
    const buildCountsMap = (items, keyName) =>
      items?.reduce((acc, cur) => {
        acc[cur.caseId] = cur[keyName];
        return acc;
      }, {}) || {};
    const totalCountsMap = buildCountsMap(documentCounts, "totalCounts");
    const totalCountsMapAcct = buildCountsMap(documentCountsForAccountant, "totalCounts");
    const hasCountsData =
      Object.keys(totalCountsMap).length > 0 || Object.keys(totalCountsMapAcct).length > 0;
    const enrichedClients = clientsData.clients.map((client) => {
      const collectionBalance = collectionBalanceFor(balancesByCaseId, client.caseId);
      return {
        ...client,
        totalCounts: hasCountsData ? (totalCountsMap[client.caseId] ?? totalCountsMapAcct[client.caseId] ?? 0) : null,
        balance: collectionBalance !== undefined ? collectionBalance : 0,
        unfinishedAssignments: assignmentsByCaseId[client.caseId] || 0,
        vatReportStatus: vatStatuses[client.caseId?.toLowerCase()] || "notReported",
        advanceReportStatus: advanceStatuses[client.caseId?.toLowerCase()] || "notReported",
        withholdingReporting: resolveWithholdingReporting(withholdingReportingStatuses, client.caseId),
      };
    });
    if (isAccountant && clientsForAccountant?.clients?.length) {
      const additional = clientsForAccountant.clients.map((client) => {
        const count = totalCountsMapAcct[client.caseId];
        const collectionBalance = collectionBalanceFor(balancesByCaseId, client.caseId);
        return {
          ...client,
          totalCounts: hasCountsData ? (count ?? 0) : null,
          balance: collectionBalance !== undefined ? collectionBalance : 0,
          unfinishedAssignments: assignmentsByCaseId[client.caseId] || 0,
          withholdingReporting: resolveWithholdingReporting(withholdingReportingStatuses, client.caseId),
        };
      });
      enrichedClients.push(...additional);
    }
    setClients(enrichedClients);
    setHasNext(clientsData.hasNext ?? false);
    setCurrentPage(1);
    setDataFetched(true);
    setClientsCount(enrichedClients.length);
  }, [
    accountantId,
    isMainPageCacheValid,
    cachedMainPageData,
    isAccountant,
    isViewOnlySubAccountant,
    clients.length,
  ]);

  // Listen for navigation state to clear cache when needed
  useEffect(() => {
    // Check if we're being told to refresh (e.g., after creating a client)
    if (location.state?.refreshCache && accountantId) {
      console.log('🔄 Navigation state indicates cache refresh needed');
      invalidateMainPageCache(accountantId);
      hasInitialFetchRef.current = false;
      fetchInProgressRef.current = false;

      // Clear the state to prevent repeated refreshes
      window.history.replaceState({}, document.title);
    }
  }, [location.state, accountantId]);

  useEffect(() => {
    const redirectIfClient = () => {
      if (userTypeContext?.toString() === Constants.UserType.Client && user) {
        // Redirect to client details page with user information
        navigate('/client-details', { state: { client: user, replace: true } });
      }
    };
    redirectIfClient();
  }, [userTypeContext, user, navigate]);


  // Use ref to track if we've initiated the fetch to prevent React StrictMode double calls

  useEffect(() => {
    // Only proceed if conditions are met
    if (permissionsLoading || !user || !token || userTypeContext?.toString() === Constants.UserType.Client) {
      return;
    }

    // Prevent duplicate fetches - check if already initiated
    if (fetchInitiatedRef.current) {
      console.log('⚠️ Fetch already initiated, skipping (React StrictMode prevention)');
      return;
    }

    // Mark immediately to prevent double execution
    fetchInitiatedRef.current = true;

    const fetchData = async () => {
      // Double-check hasInitialFetchRef before actual fetch
      if (hasInitialFetchRef.current) {
        console.log('⚠️ Initial fetch already completed, skipping duplicate');
        return;
      }

      hasInitialFetchRef.current = true;
      console.log('🚀 Starting initial data fetch (should only happen once)');

      try {
        setLoading(true);

        if (!isViewOnlySubAccountant) {
          setOptionSelected([]);
          setIsSubAccSelectDisabled(false);

          await Promise.all([
            fetchClientsData(user.accountantId, token, 1, pageSize, true, true, date),
            fetchSubAccountantsData(user.accountantId, token, true)
          ]);
        } else {
          await fetchSubAccountantIdClientsData(user.subAccountantId, user.accountantId, token, 1, pageSize, true);
          const ownOption = {
            value: user.subAccountantId,
            label: formatSubAccountantOptionLabel(user.name),
          };
          setSubAccountants([ownOption]);
          setOptionSelected([ownOption]);
          setIsSubAccSelectDisabled(true);
        }

        console.log('✅ Initial data fetch completed');
      } catch (error) {
        console.error("Error fetching data:", error);
        hasInitialFetchRef.current = false;
        fetchInitiatedRef.current = false;
        navigate("/login");
      } finally {
        setLoading(false);
        setInitialFetchComplete(true);
      }
    };

    fetchData();
  }, [permissionsLoading, user, token, userTypeContext, isAccountant, permissions, isViewOnlySubAccountant]);

  useEffect(() => {
    Object.keys(documentUpdate).forEach(updateCaseId => {
      const update = documentUpdate[updateCaseId];
      const updatedClients = clients.map(client => {
        if (client.caseId === updateCaseId) {
          return {
            ...client,
            totalCounts: update.totalCounts,
          };
        }
        return client;
      });

      setClients(updatedClients);

      // Update both Redux caches for real-time consistency
      if (accountantId && update.totalCounts !== undefined) {
        // Update document counts cache
        dispatch(updateClientCount({
          accountantId,
          caseId: updateCaseId,
          totalCounts: update.totalCounts
        }));

        // Update main page cache
        dispatch(updateClientInMainPage({
          accountantId,
          caseId: updateCaseId,
          updates: { totalCounts: update.totalCounts }
        }));
      }
    });
  }, [documentUpdate, accountantId, dispatch]);

  const loadMoreClients = () => {
    if (isViewOnlySubAccountant) {
      fetchSubAccountantIdClientsData(user.subAccountantId, user.accountantId, token, currentPage + 1, pageSize, false);
      return;
    }
    fetchClientsData(user.accountantId, token, currentPage + 1, pageSize, false, isAccountant, date);
  };

  // useEffect(() => {
  //   // Check if the refresh state is passed and true
  //   if (location.state?.refresh && location.state?.accountantId && location.state?.token) {
  //     fetchClientsData(location.state.accountantId, location.state.token, 1, 50, true, isAccountant);
  //     setNeedsRefresh(false); // Reset the refresh state
  //   }
  // }, [location.state]);

  // useEffect(() => {
  //   if (permissions && permissions.length > 0) {
  //     // Update the permissionsState based on permissions array
  //     const updatedPermissionsState = { ...permissionsState };


  //     permissions.forEach((permission) => {
  //       // Add new permissions to the state with default true
  //       if (!updatedPermissionsState[permission]) {
  //         updatedPermissionsState[permission] = true;
  //       }
  //     });

  //     setPermissionsState(updatedPermissionsState);
  //   }
  // }, [permissions]);

  const checkAndSetVatPeriodReported = async () => {
    try {
      const response = await ReportsService.isVatPeriodReportedForAccountant(accountantId, date, token);
      // The response will include a dictionary of case IDs and their status

      if (response.results) {
        setClients(prevClients => prevClients.map(client => {
          return {
            ...client,
            vatReportStatus: response.results[client.caseId.toLowerCase()] || 'notReported'
          };
        }));
      }
    } catch (error) {
      console.error('Failed to check VAT period reported status:', error);
    }
  };

  const checkAndSetAdvancePeriodReported = async () => {
    try {
      const response = await ReportsService.isAdvancePeriodReportedForAccountant(accountantId, date, token);
      // The response will include a dictionary of case IDs and their status
      if (response.results) {
        setClients(prevClients => prevClients.map(client => {
          return {
            ...client,
            advanceReportStatus: response.results[client.caseId.toLowerCase()] || 'notReported'
          };
        }));
      }
    } catch (error) {
      console.error('Failed to check Advance period reported status:', error);
    }
  };
  const baseFilteredClients = useMemo(() => {

    return clients
      .filter(client =>
        client.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        client.businessOwnerName?.toLowerCase()?.includes(searchQuery.toLowerCase()) ||
        client.caseId.toLowerCase().includes(searchQuery.toLowerCase()) ||
        client.officeIdentifyNumber?.toString()?.toLowerCase()?.includes(searchQuery.toLowerCase())
      )
      .filter(client =>
        optionSelected.length === 0 || optionSelected.some(option => option.value === client.subAccountantId)
      )
      .filter(client =>
        accountOptionSelected.length === 0 || accountOptionSelected.some(option => option.value === client.accountManagement)
      )
      .filter(client =>
        caseTypeFilter.length === 0 || caseTypeFilter.some(option => option.value === client.caseType)
      )
      .filter(client =>
        client.isActive == activeUsers
      )
      .filter(client =>
        vatStatusFilter.length === 0 || vatStatusFilter.some(option =>
          option.value === (client.vatReportStatus || 'notReported'))
      )
      .filter(client =>
        advanceStatusFilter.length === 0 || advanceStatusFilter.some(option =>
          option.value === (client.advanceReportStatus || 'notReported'))
      )
      .sort((a, b) => {
        if (sortByNewest === 'asc' || sortByNewest === 'desc') {
          const modifier = sortByNewest === 'asc' ? 1 : -1;
          return (a.totalCounts - b.totalCounts) * modifier;
        }
        if (sortOrder === 'asc') {
          return a.name.localeCompare(b.name);
        } else {
          return b.name.localeCompare(a.name);
        }
      });
  }, [
    clients, searchQuery, sortByNewest, sortOrder, optionSelected, accountOptionSelected,
    caseTypeFilter, activeUsers, vatStatusFilter, advanceStatusFilter, documentCountsVersion
  ]);

  // ManageOnly and TaxRefund clients live in their own tabs and never mix with regular clients.
  const clientTypeCounts = useMemo(() => {
    const counts = { regular: 0, manageOnly: 0, taxRefund: 0 };
    baseFilteredClients.forEach((c) => { counts[getClientTypeTab(c)] += 1; });
    return counts;
  }, [baseFilteredClients]);

  const filteredClients = useMemo(
    () => baseFilteredClients.filter((c) => getClientTypeTab(c) === clientTypeTab),
    [baseFilteredClients, clientTypeTab]
  );

  const handleClientTypeTabChange = (_event, nextTab) => {
    setClientTypeTab(nextTab);
    setSelectedClientIds([]);
    try { localStorage.setItem('main_clientTypeTab', nextTab); } catch (_) {}
  };

  console.log('filteredClients', filteredClients);
  useEffect(() => {
    setClientsCount(filteredClients.length);

  }, [filteredClients]);

  // Force DataGrid re-render when document counts are updated
  useEffect(() => {
    // Only update if counts update is pending and loading is complete
    if (countsUpdatePendingRef.current && !isLoadingDocumentCounts && clients.length > 0) {
      // Check if any client still has null totalCounts
      const hasNullCounts = clients.some(client => client.totalCounts === null);

      // Only update if all counts are loaded (no nulls)
      if (!hasNullCounts) {
        // Reset the pending flag first to prevent duplicate updates
        countsUpdatePendingRef.current = false;

        // First update version to force filteredClients recalculation
        setDocumentCountsVersion(prev => {
          const newVersion = prev + 1;
          console.log('🔄 Document counts version updated:', newVersion);
          return newVersion;
        });

        // Then update key in next tick to ensure filteredClients is recalculated first
        setTimeout(() => {
          setDataGridKey(prev => {
            const newKey = prev + 1;
            console.log('🔄 DataGrid key updated (counts loaded):', newKey, {
              clientsCount: clients.length,
              hasNulls: hasNullCounts,
              sampleCounts: clients.slice(0, 3).map(c => ({ id: c.caseId, count: c.totalCounts }))
            });
            return newKey;
          });
        }, 0);
      } else {
        // Still has nulls, keep the flag set
        console.log('⏳ Still waiting for all counts to load...', {
          clientsWithNulls: clients.filter(c => c.totalCounts === null).length
        });
      }
    }
  }, [clients, isLoadingDocumentCounts]);

  useEffect(() => {
    // Only proceed if we have clients and a valid date.
    if (clients.length > 0 && date) {
      // Check if either the date or the number of clients has changed since the last check.
      const { date: lastDate, clientCount } = lastCheckParamsRef.current;
      const shouldCheck =
        date !== lastDate || clients.length !== clientCount || dataFetched;

      if (shouldCheck) {
        // Update the ref with current parameters.
        lastCheckParamsRef.current = { date, clientCount: clients.length };

        // Call the status-checking function.
        checkAndSetPeriodsReported();

        // If the dataFetched flag was true, reset it.
        if (dataFetched) {
          setDataFetched(false);
        }
      }
    }
  }, [clients, date, dataFetched]);

  const checkAndSetPeriodsReported = async () => {
    try {
      const caseIdsForMonth = clients.map(c => c.caseId).filter(Boolean);
      const yearForMonth = date ? date.getUTCFullYear() : new Date().getUTCFullYear();
      const monthForMonth = date ? (date.getUTCMonth() + 1) : (new Date().getUTCMonth() + 1);

      // Fetch VAT, Advance, and processed-this-month counts concurrently
      const [vatResponse, advanceResponse, processedThisMonthData, withholdingReportingResponse] = await Promise.all([
        ReportsService.isVatPeriodReportedForAccountant(accountantId, date, token),
        ReportsService.isAdvancePeriodReportedForAccountant(accountantId, date, token),
        caseIdsForMonth.length
          ? DocumentService.GetProcessedDocumentCountsByMonth(caseIdsForMonth, yearForMonth, monthForMonth, token)
          : Promise.resolve([]),
        isViewOnlySubAccountant
          ? Promise.resolve(null)
          : ClientService.GetWithholdingReportingForAccountantForMonth(
            accountantId,
            yearForMonth,
            monthForMonth,
            token
          ),
      ]);

      const vatResults = vatResponse.results || {};
      const advanceResults = advanceResponse.results || {};
      const withholdingResults = withholdingReportingResponse?.results || {};
      const processedMap = {};
      (processedThisMonthData || []).forEach(r => {
        if (r && r.caseId != null) processedMap[r.caseId] = r.processedCounts ?? 0;
      });

      // Update clients with both VAT and Advance statuses using functional update
      // This ensures we're working with the latest state and preserve totalCounts
      setClients(prevClients => prevClients.map(client => {
        return {
          ...client,
          vatReportStatus: vatResults[client.caseId.toLowerCase()] || 'notReported',
          advanceReportStatus: advanceResults[client.caseId.toLowerCase()] || 'notReported',
          processedThisMonth: processedMap[client.caseId] ?? 0,
          withholdingReporting: resolveWithholdingReporting(withholdingResults, client.caseId),
        };
      }));
    } catch (error) {
      console.error('Failed to check reported statuses:', error);
    }
  };
  // const viewClientDetails = (client) => {
  //   localStorage.removeItem('dismissedDialog');
  //   navigate('/client-details', { state: { client, replace: true } });
  // };

  const headerContextValue = {
    t,
    direction,
    permissionsState,
    userTypeContext,
    clientsCount,
    beautifyNumber,
    navigate,
    clientsIcon,
    subAccountantsCount,
    subAccountantsIcon,
    Constants,
    filteredClients
  };

  const handleDownloadPdf = async () => {
    try {
      const res = await EnumsService.DownloadClientsSummaryPdf(user.accountantId, token);
      if (!res.ok) throw new Error();
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = `ClientsSummary_${user.accountantId}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch {
      toast.error(t('downloadFailed'));
    }
  };

  const handleDownloadExcel = async () => {
    try {
      const res = await EnumsService.DownloadClientsSummaryExcel(user.accountantId, token);
      if (!res.ok) throw new Error();
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = `ClientsSummary_${user.accountantId}.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch {
      toast.error(t('downloadFailed'));
    }
  };

  const getDefaultGeneratedDocsFromDate = () => {
    const d = new Date(date);
    d.setUTCMonth(d.getUTCMonth() - 11);
    return d;
  };

  const doExportGeneratedDocuments = async (filters) => {
    setLoading(true);
    try {
      const res =
        generatedDocsExportFormat === 'pdf'
          ? await TransactionDocumentsExportService.DownloadGeneratedDocumentsPdf(
            user.accountantId, filters, token)
          : await TransactionDocumentsExportService.DownloadGeneratedDocumentsExcel(
            user.accountantId, filters, token);

      if (!res.ok) throw new Error();

      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `GeneratedDocuments_${user.accountantId}.${generatedDocsExportFormat === 'pdf' ? 'pdf' : 'xlsx'}`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch {
      toast.error(t('downloadFailed'));
    } finally {
      setLoading(false);
      setGeneratedDocsExportModalOpen(false);
    }
  };

  const doExport = async (filters, caseIds = null) => {
    setLoading(true);
    const exportDate = filters?.date ?? date;
    const exportSelectedOnly = Array.isArray(caseIds) && caseIds.length > 0;

    const dto = {
      accountantId: user.accountantId,
      year: exportDate.getUTCFullYear(),
      month: exportDate.getUTCMonth() + 1,
      ...(exportSelectedOnly
        ? { caseIds }
        : {
          isActive: filters.active?.value ?? null,
          subAccIds: (filters.subAcc || []).map(o => o.value),
          accMgmt: (filters.accMgmt || []).map(o => o.value),
          reportingTypes: filters.reportingType
            ? [filters.reportingType.value]
            : [],
          vatReportStatuses: (filters.vatStatuses || []).map((o) => o.value),
          advanceReportStatuses: (filters.advanceStatuses || []).map((o) => o.value),
        }),
    };

    try {
      // choose the right service-method just like the old handlers
      const res =
        exportFormat === 'pdf'
          ? await EnumsService.DownloadClientsSummaryPdf(dto, token)   // <— POST with body
          : await EnumsService.DownloadClientsSummaryExcel(dto, token);

      if (!res.ok) throw new Error();

      // identical “save-as” block
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = `ClientsSummary_${user.accountantId}.${exportFormat === 'pdf' ? 'pdf' : 'xlsx'}`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch {
      toast.error(t('downloadFailed'));
    } finally {
      setLoading(false);
      setExportModalOpen(false);
    }
  };

  const exportSelectedClients = async (format) => {
    if (!selectedClientIds.length) {
      toast.info(t('selectClientsFirst'));
      return;
    }

    const selectedSet = new Set(selectedClientIds.map((id) => String(id)));
    const selectedClients = filteredClients.filter((c) => selectedSet.has(String(c.caseId)));
    if (!selectedClients.length) {
      toast.info(t('selectClientsFirst'));
      return;
    }

    const includeBalance = !isViewOnlySubAccountant;
    const includeWithholdingReporting = !isViewOnlySubAccountant;
    const stamp = dayjs().format('YYYYMMDD_HHmm');
    const baseName = `ClientsTable_${user.accountantId}_${stamp}`;

    setLoading(true);
    try {
      if (format === 'excel') {
        downloadClientsTableExcel({
          clients: selectedClients,
          t,
          subAccountants,
          includeBalance,
          includeWithholdingReporting,
          fileName: `${baseName}.xlsx`,
          title: t('exportSelectedTableExcel'),
        });
      } else {
        await downloadClientsTablePdf({
          clients: selectedClients,
          t,
          subAccountants,
          includeBalance,
          includeWithholdingReporting,
          fileName: `${baseName}.pdf`,
          title: t('exportSelectedTablePdf'),
          direction,
        });
      }
    } catch {
      toast.error(t('downloadFailed'));
    } finally {
      setLoading(false);
    }
  };

  const handleBulkSendNotifications = async (options) => {
    if (!selectedClientIds.length) {
      toast.info(t('selectClientsFirst'));
      return;
    }
    setBulkSendLoading(true);
    try {
      const result = await ClientService.BulkSendNotifications(token, {
        caseIds: selectedClientIds,
        ...options,
      });
      const successCount = result?.successCount ?? 0;
      const total = result?.total ?? selectedClientIds.length;
      if (successCount === total) {
        toast.success(t('bulkSendSuccess'));
      } else if (successCount > 0) {
        toast.warning(t('bulkSendPartialFailure', { success: successCount, total }));
      } else {
        toast.error(t('downloadFailed'));
      }
      setBulkSendModalOpen(false);
    } catch (err) {
      toast.error(typeof err?.message === 'string' ? err.message : t('downloadFailed'));
    } finally {
      setBulkSendLoading(false);
    }
  };




  /* ——— open details, maybe after pwd check ——— */
  const goToDetails = (client) => {
    localStorage.removeItem('dismissedDialog');
    // Reset all client-specific redux state so the new client never shows
    // stale data from a previously opened client.
    resetAllClientReduxData();
    navigate('/client-details', { state: { client, replace: true } });
  };

  /* ——— row click handler ——— */
  const viewClientDetails = async (client) => {
    // First check if client is blocked (self-paying and blocked) - only on click
    const paysForSelf = client.clientPaymentMethod === 1 ||
      client.clientPaymentMethod === Constants.clientPaymentMethodOptionsEnum?.Client;

    if (paysForSelf) {
      try {
        // Check client status to see if blocked
        const status = await PaymentService.client.status(client.caseId);
        if (status?.isBlocked) {
          // Client is blocked - show blocker window with balance calculation
          setBlockedClient(client);
          setShowBlockerWindow(true);
          return; // Don't proceed to client details
        }
      } catch (error) {
        console.error(`Error checking status for client ${client.caseId}:`, error);
        // Continue with normal flow if status check fails
      }
    }

    // Normal flow: check office password
    if (!client.isHaveOfficePassword) {                // no lock
      goToDetails(client);
      return;
    }
    // locked → show dialog
    setSelectedClient(client);
    setPwdValue('');
    setPwdError("");
    setPwdDialogOpen(true);
  };

  /* ——— submit password ——— */
  const handlePwdSubmit = async () => {
    if (!selectedClient) return;

    // Check if client is blocked before allowing access even with correct password
    const paysForSelf = selectedClient.clientPaymentMethod === 1 ||
      selectedClient.clientPaymentMethod === Constants.clientPaymentMethodOptionsEnum?.Client;

    if (paysForSelf) {
      try {
        const status = await PaymentService.client.status(selectedClient.caseId);
        if (status?.isBlocked) {
          // Client is blocked - show blocker window instead of proceeding
          setPwdDialogOpen(false);
          setBlockedClient(selectedClient);
          setShowBlockerWindow(true);
          return;
        }
      } catch (error) {
        console.error(`Error checking status for client ${selectedClient.caseId}:`, error);
        // Continue with password verification if status check fails
      }
    }

    try {
      const res = await ClientService.VerifyLoginOffice(
        selectedClient.caseId,
        pwdValue,
        token
      );

      if (res.ok) {
        setPwdDialogOpen(false);
        goToDetails(selectedClient);
        setPwdError("");
      } else {
        toast.error(t('WrongPassword'));
        setPwdError(t("WrongPassword"));
      }
    } catch {
      toast.error(t('serverError'));
    }
  };

  const handleWithholdingReportingToggle = async (client) => {
    if (withholdingReportingSavingCaseId) return;

    const newValue = !client.withholdingReporting;
    const year = date.getUTCFullYear();
    const month = date.getUTCMonth() + 1;
    const monthLabel = `${String(month).padStart(2, '0')}/${year}`;

    const confirmed = await confirmWithholdingReporting({
      t,
      direction,
      clientName: client.name,
      monthLabel,
      enable: newValue,
    });
    if (!confirmed) return;

    setClients((prev) =>
      prev.map((c) =>
        c.caseId === client.caseId ? { ...c, withholdingReporting: newValue } : c
      )
    );
    if (accountantId) {
      dispatch(
        updateClientInMainPage({
          accountantId,
          caseId: client.caseId,
          updates: { withholdingReporting: newValue },
        })
      );
    }

    setWithholdingReportingSavingCaseId(client.caseId);
    try {
      await ClientService.UpdateWithholdingReporting(token, client.caseId, year, month, newValue);
      toast.success(t('WithholdingReportingUpdatedSuccessfully'));
    } catch {
      setClients((prev) =>
        prev.map((c) =>
          c.caseId === client.caseId ? { ...c, withholdingReporting: !newValue } : c
        )
      );
      if (accountantId) {
        dispatch(
          updateClientInMainPage({
            accountantId,
            caseId: client.caseId,
            updates: { withholdingReporting: !newValue },
          })
        );
      }
      toast.error(t('serverError'));
    } finally {
      setWithholdingReportingSavingCaseId(null);
    }
  };

  /** Mirrors withholding reporting changes made in the reporting follow-up overview into the grid. */
  const handleFollowUpWithholdingChange = ({ caseId, year, months, value }) => {
    if (!date || date.getUTCFullYear() !== year || !months.includes(date.getUTCMonth() + 1)) return;
    setClients((prev) =>
      prev.map((c) => (c.caseId === caseId ? { ...c, withholdingReporting: value } : c))
    );
    if (accountantId) {
      dispatch(
        updateClientInMainPage({
          accountantId,
          caseId,
          updates: { withholdingReporting: value },
        })
      );
    }
  };

  // The overview endpoints deny sub-accountants restricted to their own clients.
  const canUseFollowUpOverview = !!accountantId && !isViewOnlySubAccountant;

  const openFollowUpOverview = (onlySelected) => {
    if (onlySelected) {
      const selectedSet = new Set(selectedClientIds.map((id) => String(id)));
      setFollowUpOverviewClients(clients.filter((c) => selectedSet.has(String(c.caseId))));
    } else {
      // Include ManageOnly / TaxRefund as well — the type tabs only split the main grid.
      setFollowUpOverviewClients(baseFilteredClients);
    }
  };

  // Reports made in the reporting follow-up modal (VAT, advances, withholding) refresh the grid statuses.
  const refreshReportedStatusesRef = useRef(null);
  refreshReportedStatusesRef.current = checkAndSetPeriodsReported;
  useEffect(() => {
    const handleSaved = () => refreshReportedStatusesRef.current?.();
    window.addEventListener(REPORTING_FOLLOW_UP_SAVED_EVENT, handleSaved);
    return () => window.removeEventListener(REPORTING_FOLLOW_UP_SAVED_EVENT, handleSaved);
  }, []);

  return (
    <>
      {loginEnter && (
        <div
          className={`${Styles['login-enter-overlay']} ${loginEnterHiding ? Styles['is-hiding'] : ''}`.trim()}
          aria-hidden="true"
        >
          <BrandXMark
            className={Styles['login-enter-x']}
            busy={!loginEnterHiding}
            showLogo
            logoSurface="blue"
            armClassNames={{
              tl: `${Styles['login-enter-x-arm']} ${Styles['login-enter-x-arm-tl']}`,
              tr: `${Styles['login-enter-x-arm']} ${Styles['login-enter-x-arm-tr']}`,
              bl: `${Styles['login-enter-x-arm']} ${Styles['login-enter-x-arm-bl']}`,
              br: `${Styles['login-enter-x-arm']} ${Styles['login-enter-x-arm-br']}`,
            }}
          />
        </div>
      )}
      <>
        <ClientProvider client={user ?? { accountantId: null, caseId: null }}>
          <div
            className={arrivingFromLogin ? Styles['main-page-from-login'] : undefined}
            dir={direction}
          >
          <div className={`${Styles['main-title']} ${Styles[direction]}`}>{t('clientFolders')}</div>

          <ClientHeaderProvider value={headerContextValue}>
            <AccountantCards clientsMode={true} />
          </ClientHeaderProvider>

          <div className={`${Styles.filtersBarMainPage} ${Styles[direction]} filtersBarMainPage`} >
            <TextField
              size="small"
              fullWidth
              dir={direction}
              placeholder={t('searchClient')}
              value={searchQuery}
              onChange={handleSearchChange}
              className={Styles['search-bar']}
              variant="standard"
              InputProps={{
                disableUnderline: true,
                className: `custom-input-box-sizing ${direction === 'ltr' ? 'ltr-input' : 'rtl-input'}`,
                sx: {
                  display: 'flex',
                  alignItems: 'center',
                  height: '100%',
                  '& .MuiInputAdornment-root': {
                    height: 'auto',
                    maxHeight: 'none',
                    display: 'flex',
                    alignItems: 'center',
                  },
                  '& input': {
                    padding: 0,
                    height: 'auto',
                    display: 'flex',
                    alignItems: 'center',
                  },
                },
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon className={Styles['search-icon']} />
                  </InputAdornment>
                ),
              }}
            />
            <div className={Styles.filtersSelect}>
              <AutocompleteSelectFilter
                options={subAccountants}
                selectedValues={optionSelected}
                onChange={handleSubAccChange}
                label={t("SubAccountant")}
                placeholder={t("SubAccountant")}
                isDisabled={isSubAccSelectDisabled}
                direction={direction}
              />
            </div>
            <div className={Styles.filtersSelect}>
              <AutocompleteSelectFilter
                options={accountingManagementType}
                selectedValues={accountOptionSelected}
                onChange={handleAccManagmentChange}
                label={t("AccountManagement")}
                placeholder={t("AccountManagement")}
                direction={direction}
              />
            </div>
            <div className={Styles.filtersSelect}>
              <AutocompleteSelectFilter
                options={caseTypeOptions}
                selectedValues={caseTypeFilter}
                onChange={handleCaseTypeFilterChange}
                label={t("caseType")}
                placeholder={t("caseType")}
                direction={direction}
              />
            </div>

            {isAccountant && (
              <div className={Styles.filtersSelect}>
                <AutocompleteSelectFilter
                  options={activeOption}
                  selectedValues={activeUsersOption}
                  onChange={handleActiveUsersChange}
                  label={t("ActiveInactiveClients")}
                  placeholder={t("ActiveInactiveClients")}
                  isMultiple={false}
                  direction={direction}
                />
              </div>
            )}
            <div className={Styles.filtersSelect}>
              <AutocompleteSelectFilter
                options={reportStatusOptions}
                selectedValues={vatStatusFilter}
                onChange={(event, newValue) => setVatStatusFilter(newValue || [])}
                label={t("VATReport")}
                placeholder={t("VATReport")}
                direction={direction}
              />
            </div>
            <div className={`${Styles.filtersSelect} ${Styles.advanceSelectDesktop}`}>
              <AutocompleteSelectFilter
                options={reportStatusOptions}
                selectedValues={advanceStatusFilter}
                onChange={(event, newValue) => setAdvanceStatusFilter(newValue || [])}
                label={t("AdvanceTaxReport")}
                placeholder={t("AdvanceTaxReport")}
                direction={direction}
              />
            </div>
            <div className={Styles.filtersSelectDateRow}>
              <div className={`${Styles.filtersSelect} ${Styles.advanceSelectMobile}`}>
                <AutocompleteSelectFilter
                  options={reportStatusOptions}
                  selectedValues={advanceStatusFilter}
                  onChange={(event, newValue) => setAdvanceStatusFilter(newValue || [])}
                  label={t("AdvanceTaxReport")}
                  placeholder={t("AdvanceTaxReport")}
                  direction={direction}
                />
              </div>
              <div className={Styles.filtersDate}>
                <FilterMonthYearPicker
                  year={date}
                  month={date}
                  onYearChange={(newYear) => handleDateChange(newYear, 'year')}
                  onMonthChange={(newMonth) => handleDateChange(newMonth, 'month')}
                  labelYear={t("Year")}
                  labelMonth={t("Month")}
                  direction={direction}
                />
              </div>
            </div>
            {/* 
            <div style={{ marginRight: 'auto' }}>
              <SummaryBar clients={filteredClients} t={t} />
            </div> */}
          </div> 

          <div className={`${Styles['export-buttons']} ${Styles[direction]}`} dir={direction}>
           
            <div className={Styles.tableViewGroup}>
              <FormControl
                size="small"
                className={Styles.tableViewControl}
                sx={{
                  minWidth: 'var(--xtram-select-min-width, 110px)',
                  maxWidth: '100%',
                  '& .MuiOutlinedInput-root': {
                    height: 'var(--xtram-control-height-sm, 32px)',
                    minHeight: 'var(--xtram-control-height-sm, 32px)',
                    fontSize: 'var(--xtram-table-view-font, 12px)',
                  },
                  '& .MuiInputBase-input, & .MuiSelect-select': {
                    fontSize: 'var(--xtram-table-view-font, 12px)',
                  },
                  '& .MuiInputLabel-root': {
                    fontSize: 'var(--xtram-table-view-label, 11px)',
                  },
                }}
              >
                <InputLabel id="main-tv-label">{t('TableView')}</InputLabel>
                <Select
                  labelId="main-tv-label"
                  value={tableView}
                  label={t('TableView')}
                  dir={direction}
                  sx={{
                    height: 'var(--xtram-control-height-sm, 32px)',
                    minHeight: 'var(--xtram-control-height-sm, 32px)',
                    fontSize: 'var(--xtram-table-view-font, 12px)',
                    '& .MuiSelect-select': {
                      textAlign: direction === 'rtl' ? 'left' : 'right',
                      fontSize: 'var(--xtram-table-view-font, 12px)',
                      py: 0,
                      display: 'flex',
                      alignItems: 'center',
                    },
                  }}
                  onChange={(e) => {
                    setTableView(e.target.value);
                    try { localStorage.setItem('main_ClientsDataGrid_tableView', e.target.value); } catch (_) {}
                  }}
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        mt: 0.5,
                        borderRadius: '8px',
                        border: '1px solid #e5e7f6',
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                        overflow: 'hidden',
                        minWidth: 'var(--xtram-menu-width)',
                        '& .MuiList-root': {
                          p: 0,
                        },
                        '& .MuiMenuItem-root': {
                          minHeight: 'var(--xtram-menu-item-height)',
                          px: 'var(--xtram-menu-item-pad-x)',
                          py: 'var(--xtram-menu-item-pad-y)',
                          fontSize: 'var(--xtram-text-sm)',
                          fontWeight: 400,
                          lineHeight: 1.35,
                          color: '#696665',
                          transition: 'background-color 0.2s ease, color 0.2s ease',
                          '&:not(:last-of-type)': {
                            borderBottom: '1px solid #f0f0f0',
                          },
                          '&:hover': {
                            backgroundColor: '#304fff',
                            color: '#ffffff',
                          },
                          '&.Mui-selected': {
                            backgroundColor: 'rgba(48, 79, 255, 0.1)',
                            color: '#304fff',
                            fontWeight: 500,
                          },
                          '&.Mui-selected:hover': {
                            backgroundColor: '#304fff',
                            color: '#ffffff',
                          },
                        },
                      },
                    },
                  }}
                >
                  <MenuItem dir={direction} value="compact">{t('TableViewCompact')}</MenuItem>
                  <MenuItem dir={direction} value="standard">{t('TableViewStandard')}</MenuItem>
                  <MenuItem dir={direction} value="full">{t('TableViewFull')}</MenuItem>
                  <MenuItem dir={direction} value="custom">{t('TableViewCustom')}</MenuItem>
                </Select>
              </FormControl>
              <Button
                variant="outlined"
                size="small"
                startIcon={<ViewColumnIcon />}
                onClick={(e) => setColumnsPanelAnchor(e.currentTarget)}
                className={Styles.columnsBtn}
                sx={{
                  minHeight: 'var(--xtram-control-height-sm, 32px)',
                  height: 'var(--xtram-control-height-sm, 32px)',
                  textTransform: 'none',
                  borderRadius: '10px',
                  borderColor: '#e5e7f6',
                  color: '#304FFF',
                  fontSize: 'var(--xtram-table-view-label, 11px)',
                  fontWeight: 600,
                  background: '#f5f6fd',
                  '&:hover': { borderColor: '#304FFF', background: '#eaedff' },
                }}
              >
                {t('ShowHideColumns')}
              </Button>
              <Tooltip title={t('FitColumnsTooltip')}>
                <Button
                  variant={fitColumns ? 'contained' : 'outlined'}
                  size="small"
                  startIcon={<FitScreenIcon />}
                  onClick={() => {
                    if (!fitColumns) setFitColumnsPersisted(true);
                    setFitNonce((n) => n + 1);
                  }}
                  aria-pressed={fitColumns}
                  className={Styles.columnsBtn}
                  sx={{
                    minHeight: 'var(--xtram-control-height-sm, 32px)',
                    height: 'var(--xtram-control-height-sm, 32px)',
                    textTransform: 'none',
                    borderRadius: '10px',
                    borderColor: '#304FFF',
                    color: fitColumns ? '#ffffff' : '#304FFF',
                    fontSize: 'var(--xtram-table-view-label, 11px)',
                    fontWeight: 600,
                    background: fitColumns ? '#304FFF' : '#f5f6fd',
                    boxShadow: 'none',
                    '&:hover': {
                      borderColor: '#304FFF',
                      background: fitColumns ? '#2538d6' : '#eaedff',
                      boxShadow: 'none',
                    },
                  }}
                >
                  {t('FitColumns')}
                </Button>
              </Tooltip>
            </div>
            <Chip
              className={`${Styles.exportChip} ${Styles.exportChipPdf}`}
              icon={<PictureAsPdfIcon />}
              label={t('exportClientsSummaryPdf')}
              onClick={() => { setExportFormat('pdf'); setExportModalOpen(true); }}
              clickable
              variant="outlined"
              dir={direction}
            />
            <Chip
              className={`${Styles.exportChip} ${Styles.exportChipExcel}`}
              icon={<TableChartIcon />}
              label={t('exportClientsSummaryExcel')}
              onClick={() => { setExportFormat('excel'); setExportModalOpen(true); }}
              clickable
              variant="outlined"
              dir={direction}
            />
            <Chip
              className={`${Styles.exportChip} ${Styles.exportChipDocsPdf}`}
              icon={
                <span className={`${Styles.exportChipIconBox} ${Styles.exportChipIconBoxBlue}`}>
                  <ArticleIcon />
                </span>
              }
              label={t('exportGeneratedDocumentsPdf')}
              onClick={() => { setGeneratedDocsExportFormat('pdf'); setGeneratedDocsExportModalOpen(true); }}
              clickable
              variant="outlined"
              dir={direction}
            />
            <Chip
              className={`${Styles.exportChip} ${Styles.exportChipDocsExcel}`}
              icon={
                <span className={`${Styles.exportChipIconBox} ${Styles.exportChipIconBoxNavy}`}>
                  <ArticleIcon />
                </span>
              }
              label={t('exportGeneratedDocumentsExcel')}
              onClick={() => { setGeneratedDocsExportFormat('excel'); setGeneratedDocsExportModalOpen(true); }}
              clickable
              variant="outlined"
              dir={direction}
            />
            {canUseFollowUpOverview && (
              <Chip
                className={`${Styles.exportChip} ${Styles.exportChipDocsPdf}`}
                icon={
                  <span className={`${Styles.exportChipIconBox} ${Styles.exportChipIconBoxBlue}`}>
                    <FactCheckIcon />
                  </span>
                }
                label={t('FollowUpOverviewTitle')}
                onClick={() => openFollowUpOverview(false)}
                clickable
                variant="outlined"
                dir={direction}
              />
            )}
          </div>

          {selectedClientIds.length > 0 && (
            <Box
              className="bulk-selection-bar"
              sx={{
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                gap: 1,
                mb: 1.5,
                p: 1.5,
                borderRadius: 1,
                border: '1px solid',
                borderColor: 'primary.main',
                bgcolor: 'rgba(48, 79, 255, 0.06)',
              }}
              dir={direction}
            >
              <Typography variant="body2" sx={{ fontWeight: 600, mr: 1 }}>
                {t('selectedClientsCount', { count: selectedClientIds.length })}
              </Typography>
              <Chip
                icon={<PictureAsPdfIcon sx={{ color: '#D32F2F !important' }} />}
                label={t('exportSelectedTablePdf')}
                onClick={() => exportSelectedClients('pdf')}
                clickable
                variant="outlined"
                size="small"
                sx={{ borderColor: '#D32F2F' }}
              />
              <Chip
                icon={<TableChartIcon sx={{ color: '#1D6F42 !important' }} />}
                label={t('exportSelectedTableExcel')}
                onClick={() => exportSelectedClients('excel')}
                clickable
                variant="outlined"
                size="small"
                sx={{ borderColor: '#1D6F42' }}
              />
              <Chip
                icon={<ArticleIcon sx={{ color: '#304FFF !important' }} />}
                label={t('exportSelectedSummary')}
                onClick={() => {
                  setExportFormat('pdf');
                  setExportModalOpen(true);
                }}
                clickable
                variant="outlined"
                size="small"
                sx={{ borderColor: '#304FFF' }}
              />
              <Chip
                icon={<SendIcon sx={{ color: '#304FFF !important' }} />}
                label={t('bulkSendNotifications')}
                onClick={() => setBulkSendModalOpen(true)}
                clickable
                variant="outlined"
                size="small"
                sx={{ borderColor: '#304FFF' }}
              />
              {canUseFollowUpOverview && (
                <Chip
                  icon={<FactCheckIcon sx={{ color: '#304FFF !important' }} />}
                  label={t('FollowUpOverviewForSelected')}
                  onClick={() => openFollowUpOverview(true)}
                  clickable
                  variant="outlined"
                  size="small"
                  sx={{ borderColor: '#304FFF' }}
                />
              )}
              <Chip
                icon={<CloseIcon />}
                label={t('clearSelection')}
                onClick={() => setSelectedClientIds([])}
                clickable
                variant="outlined"
                size="small"
              />
            </Box>
          )}

          {isAccountant && (transferRequestsAssignedToMe.length > 0 || transferRequestsLoading) && (
            <Box sx={{ mb: 2, p: 2, borderRadius: 1, border: '1px solid', borderColor: 'divider', bgcolor: 'background.paper' }} dir={direction}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                  {t('TransferRequestsAssignedToMe')}
                </Typography>
                <Tooltip title={t('Refresh')}>
                  <IconButton size="small" onClick={fetchTransferRequests} disabled={transferRequestsLoading}>
                    <RefreshIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </Box>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
                {t('TransferRequestAssignedMessage')}
              </Typography>
              {transferRequestsLoading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
                  <CircularProgress size={24} />
                </Box>
              ) : transferRequestsAssignedToMe.length === 0 ? (
                <Typography variant="body2" color="text.secondary">{t('NoTransferRequestsAssignedToMe')}</Typography>
              ) : (
                <TableContainer component={Paper} sx={{ maxHeight: 220, borderRadius: 1 }}>
                  <Table size="small" stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 700, fontSize: 'var(--xtram-text-xs)' }}>{t('RequestTransferClient')}</TableCell>
                        <TableCell sx={{ fontWeight: 700, fontSize: 'var(--xtram-text-xs)' }}>{t('RequestTransferSourceAccountant')}</TableCell>
                        <TableCell sx={{ fontWeight: 700, fontSize: 'var(--xtram-text-xs)' }} align="right">{t('RequestTransferActions')}</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {transferRequestsAssignedToMe.map((row) => (
                        <TableRow key={row.id}>
                          <TableCell sx={{ fontSize: 'var(--xtram-text-sm)' }}>{row.clientName || row.caseId || '—'}</TableCell>
                          <TableCell sx={{ fontSize: 'var(--xtram-text-sm)' }}>{row.sourceAccountantName || row.sourceAccountantId || '—'}</TableCell>
                          <TableCell align="right">
                            <Tooltip title={t('RequestTransferApprove')}>
                              <IconButton
                                size="small"
                                disabled={transferRequestActionId === row.id}
                                onClick={() => handleTransferApprove(row.id)}
                                sx={{ color: 'success.main' }}
                              >
                                {transferRequestActionId === row.id ? <CircularProgress size={18} /> : <CheckCircleIcon fontSize="small" />}
                              </IconButton>
                            </Tooltip>
                            <Tooltip title={t('RequestTransferReject')}>
                              <IconButton
                                size="small"
                                disabled={transferRequestActionId === row.id}
                                onClick={() => handleTransferReject(row.id)}
                                sx={{ color: 'error.main' }}
                              >
                                {transferRequestActionId === row.id ? <CircularProgress size={18} /> : <CancelIcon fontSize="small" />}
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </Box>
          )}

          <Tabs
            value={clientTypeTab}
            onChange={handleClientTypeTabChange}
            dir={direction}
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              minHeight: 36,
              mb: 1,
              borderBottom: '1px solid rgba(0,0,0,0.08)',
              '& .MuiTab-root': {
                minHeight: 36,
                textTransform: 'none',
                fontWeight: 600,
                fontSize: 'var(--xtram-text-sm, 13px)',
              },
            }}
          >
            {CLIENT_TYPE_TABS.map((tab) => (
              <Tab
                key={tab}
                value={tab}
                label={`${t(tab === 'regular' ? 'ClientsTabRegular' : tab === 'manageOnly' ? 'ClientsTabManageOnly' : 'ClientsTabTaxRefund')} (${clientTypeCounts[tab]})`}
              />
            ))}
          </Tabs>

          <ClientsDataGrid
            key={dataGridKey}
            filteredClients={filteredClients}
            viewClientDetails={viewClientDetails}
            activeUsers={activeUsers}
            subAccountants={subAccountants}
            ViewSubAccountantClients={isViewOnlySubAccountant}
            isLoadingDocumentCounts={isLoadingDocumentCounts}
            onWithholdingReportingToggle={handleWithholdingReportingToggle}
            withholdingReportingSavingCaseId={withholdingReportingSavingCaseId}
            selectedRowIds={selectedClientIds}
            onSelectedRowIdsChange={setSelectedClientIds}
            columnsPanelAnchor={columnsPanelAnchor}
            onColumnsPanelClose={() => setColumnsPanelAnchor(null)}
            tableView={tableView}
            onTableViewChange={setTableView}
            fitToScreen={fitColumns}
            fitNonce={fitNonce}
          />

          <PasswordDialog
            open={pwdDialogOpen}
            onClose={() => setPwdDialogOpen(false)}
            onSubmit={handlePwdSubmit}
            pwdValue={pwdValue}
            setPwdValue={setPwdValue}
            showPassword={showPassword}
            handleClickShowPassword={handleClickShowPassword}
            handleMouseDownPassword={handleMouseDownPassword}
            direction={direction}
            pwdError={pwdError}
          />

          <button
            className={`${Styles['load-more']} ${!hasNext ? (Styles.disabled || 'disabled') : ''}`.trim()}
            onClick={loadMoreClients}
            disabled={!hasNext}
          >
            <span>{t('loadMoreClients')}</span>
            <RefreshIcon className={Styles['load-more-icon']} />
          </button>
          </div>
        </ClientProvider>
      </>
      <ToastContainer />
      <ClientBlockerWindow
        open={showBlockerWindow}
        onClose={() => {
          setShowBlockerWindow(false);
          setBlockedClient(null);
        }}
        client={blockedClient}
        token={token}
        accountantName={user?.name}
        accountantId={user?.accountantId || user?.id}
        userType={userTypeContext || 2}
        showMoveButton={isAccountant} // Show move button for Accountants and SubAccountants
        onSuccess={() => {
          // Refresh clients data after payment success
          setShowBlockerWindow(false);
          setBlockedClient(null);
          // Cache is already invalidated in ClientBlockerWindow, just refetch
          if (user?.accountantId) {
            hasInitialFetchRef.current = false;
            fetchInProgressRef.current = false;
            if (isViewOnlySubAccountant) {
              fetchSubAccountantIdClientsData(user.subAccountantId, user.accountantId, token, 1, pageSize, true);
            } else {
              fetchClientsData(user.accountantId, token, 1, pageSize, true, true, date);
            }
          }
        }}
      />
      <ExportClientsModal
        open={exportModalOpen}
        onClose={() => setExportModalOpen(false)}
        onExport={doExport}
        subAccountants={subAccountants}
        accountingManagementType={accountingManagementType}
        activeOption={activeOption}
        defaultFilters={{
          subAcc: optionSelected,
          accMgmt: accountOptionSelected,
          active: activeUsersOption,
          date: date,
          vatStatuses: [],
          advanceStatuses: [],
        }}
      />
      <ReportingFollowUpOverviewModal
        open={!!followUpOverviewClients}
        onClose={() => setFollowUpOverviewClients(null)}
        clients={followUpOverviewClients || []}
        user={user}
        token={token}
        defaultDate={date ? new Date(date.getUTCFullYear(), date.getUTCMonth(), 1) : undefined}
        onWithholdingReportingChange={handleFollowUpWithholdingChange}
      />
      <BulkClientActionsModal
        open={bulkSendModalOpen}
        onClose={() => setBulkSendModalOpen(false)}
        onSend={handleBulkSendNotifications}
        selectedCount={selectedClientIds.length}
        loading={bulkSendLoading}
      />
      <ExportGeneratedDocumentsModal
        open={generatedDocsExportModalOpen}
        onClose={() => setGeneratedDocsExportModalOpen(false)}
        onExport={doExportGeneratedDocuments}
        subAccountants={subAccountants}
        accountingManagementType={accountingManagementType}
        activeOption={activeOption}
        defaultFilters={{
          subAcc: optionSelected,
          accMgmt: accountOptionSelected,
          active: activeUsersOption,
          fromDate: getDefaultGeneratedDocsFromDate(),
          toDate: date,
          vatStatuses: [],
          advanceStatuses: [],
        }}
      />
      {loading && (
        <div className={Styles['loader-container']}>
          <PuffLoader
            size={100}        // Larger size for better visibility
            loading={loading}
          />
        </div>
      )}
    </>
  );
};

export default Main;
